import axiosClient from './axiosClient';

export interface ExportCsvConfigDto {
  id?: number;
  name: string;
  description?: string | null;
  selectedFields: string[];
  delimiter?: string;
  includeHeaders?: boolean;
  isShared?: boolean;
  mappingConfigId: number;
  createdAt?: string;
  updatedAt?: string;
}

export const exportCsvApi = {
  listConfigs: async (mappingConfigId?: number) => {
    const resp = await axiosClient.get('/export-csv/configs', { params: { mappingConfigId } });
    return resp.data as ExportCsvConfigDto[];
  },
  createConfig: async (payload: Omit<ExportCsvConfigDto, 'id' | 'createdAt' | 'updatedAt'>) => {
    const resp = await axiosClient.post('/export-csv/configs', payload);
    return resp.data as ExportCsvConfigDto;
  },
  getConfig: async (id: number) => {
    const resp = await axiosClient.get(`/export-csv/configs/${id}`);
    return resp.data as ExportCsvConfigDto;
  },
  updateConfig: async (id: number, payload: Partial<ExportCsvConfigDto>) => {
    const resp = await axiosClient.put(`/export-csv/configs/${id}`, payload);
    return resp.data as ExportCsvConfigDto;
  },
  deleteConfig: async (id: number) => {
    const resp = await axiosClient.delete(`/export-csv/configs/${id}`);
    return resp.data as { success: boolean };
  },
  getAvailableFields: async (mappingConfigId: number) => {
    const resp = await axiosClient.get('/export-csv/available-fields', { params: { mappingConfigId } });
    return resp.data as string[];
  },
  getAvailableFieldsDetailed: async (mappingConfigId: number) => {
    const resp = await axiosClient.get('/export-csv/available-fields-detailed', { params: { mappingConfigId } });
    return resp.data as Array<{ path: string; example?: string }>;
  },
  download: async (payload: { mappingConfigId: number; selectedFields: string[]; delimiter?: string; includeHeaders?: boolean; }) => {
    const resp = await axiosClient.post('/export-csv/download', payload, { responseType: 'blob' });
    return resp.data as Blob;
  },
};


